import { CallApi, handleJSONResponse } from './common';
import { SearchRequest } from '@services/search/types/search-request';
import { TracInviteTypes } from '@services/invites/types/invite-types';

const callAPI = CallApi('search');

export const search = async (index: string, q: SearchRequest) => {
  const response = await callAPI(`/${ index }`, 'POST', q);

  return await handleJSONResponse(response);
}

export const categories = (type: string, k: string, v: string) => search('categories', [{"sk": type}, {[k]: `${v}*`}]);

export const genre = (name: string) => categories('genre', 'name', name);
export const region = (name: string) => categories('region', 'name', name);
export const recordLabel = (name: string) => categories('record-label', 'name', name);
export const platform = (name: string) => categories('platform', 'name', name);

export const users = (data: string) => search('users', [{fullName: data, email: data, telephone: data}]);
export const invites = (data: string, type: TracInviteTypes) => search('invites', [{ type }, {name: data, email_or_phone: data}]);
export const artists = (data: string) => search('artists', [{name: data}]);